import React from "react"
import PropTypes from "prop-types"
import {Link, withRouter} from 'react-router-dom';
import {Col, FormControl, FormGroup, Row} from "react-bootstrap"
import {TableHeaderColumn} from "react-bootstrap-table"
import BaseGrid from "../BaseGrid"
import FormButtons from "../form/FormButtons"
import {Acl, Grid, Enums, qs} from "../../utils"

class Users extends BaseGrid {

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			action: null,
			actionModalOpen: null,
			actionItems: []
		};

		this.handleActionSelect = this.handleActionSelect.bind(this);
		this.handleActionSubmit = this.handleActionSubmit.bind(this);
		this.handleRowSelect = this.handleRowSelect.bind(this);
		this.handleRowSelectAll = this.handleRowSelectAll.bind(this);

		this.handleActionModalDismiss = this.handleActionModalDismiss.bind(this)
	}

	getDefaultFilter() {
		return {
			"statuses": ["NEW", "ACTIVE"],
			"roleIds": null,
			"positionIds": null,

			"search": "",
			"orderCol": "lastName",
			"orderDir": "a",
			"start": 0,
			"rows": this.getDefaultPageRows()
		}
	}

	handleRowSelect({userId}, isSelected) {
		const {actionItems} = this.state;
		if (isSelected) {
			this.setState({
				actionItems: [...actionItems, userId].sort()
			});
		} else {
			this.setState({actionItems: actionItems.filter(it => it !== userId)});
		}
		return false;
	}

	handleRowSelectAll(isSelected) {
		const {items, session} = this.props;
		if (!isSelected) {
			this.setState({actionItems: []})
		} else {
			const actionItems = [];
			for (let i = 0; i < items.length; i++) {
				if (!Acl.isAllowed(session, Acl.right.USER_NEW_GLOBAL) && items[i].userId) {
					continue
				}
				actionItems.push(items[i].userId)
			}
			this.setState({actionItems: actionItems})
		}
	}

	handleActionSelect(action) {
		this.setState({action: action})
	}

	handleActionSubmit() {
		const {actionItems, action} = this.state;
		if (!actionItems || !actionItems.length || !action || !action.value) {
			return
		}

		if ("archive" === action.value) {
			this.props.onShowModal(
				'Hromadné ukončení činnosti',
				'Skutečně hromadně ukončit činnost vybraných členů (' + actionItems.length + ')?',
				{style: 'danger', label: 'Hromadně ukončit činnost', icon: 'trash'},
				() => this.props.onUpdateUserStatus("deleted", actionItems).then((json) => {
					if (json && json.response && json.response.result === 'OK') {
						this.onFilterChange()
					} else {
						return new Promise((resolve, reject) => reject())
					}
				})
			)

		} else {
			this.setState({actionModalOpen: true})
		}
	}

	handleActionModalDismiss() {
		this.setState({actionModalOpen: false})
	}

	renderActionModal() {
		// const {session} = this.props;
		const {actionModalOpen, actionItems} = this.state
		if (!actionModalOpen) {
			return null
		}
		const {items} = this.props;
		const selected = [];
		if (items && items.length) {
			for (let i = 0; i < items.length; i++) {
				if (actionItems.indexOf(items[i].userId) >= 0) {
					selected.push(items[i])
				}
			}
		}
	}

	handleSelectChange(name, value, submit = false) {
		const {filter} = this.state;
		// if (name === "eventId") {
		// 	if (filter.eventId && filter.eventId === value) {
		// 		return
		// 	}
		// 	const key = Enums.getKey("races", filter);
		// 	if (this.props.enums[key] && this.props.enums[key]["items"] && this.props.enums[key]["items"].length > 0) {
		// 		// auto-select 1st option
		// 		filter.raceId = this.props.enums[key]["items"][0]['id']
		// 	} else {
		// 		filter.raceId = ""
		// 	}
		// 	filter.compGroupIds = []
		// }
		// if (name === "raceId") {
		// 	if (filter.raceId && filter.raceId === value) {
		// 		return
		// 	}
		// 	filter.compGroupIds = []
		// }

		console.log("select changed " + name + " => " + value);
		filter[name] = value;
		this.setState({filter: filter}, () => {
			// if (name === "xxx") {
				// this.props.onFetchEnums(["xxx", "xxx"], value, null, filter)
			// }
			this.onFilterChange()
		})
	}

	onFilterReset() {
		// const {filter} = this.state;
		// const {enums} = this.props;

		this.setState({filter: Object.assign({}, this.getDefaultFilter())}, () => {
			if (this.refs.table) {
				this.refs.table.reset()
			}
			this.onFilterChange()
		})

	}

	formatSex(cell, row) {
		switch (cell) {
			case "F":
				return "Ž";
			default:
				return cell
		}
	}

	formatStatus(cell, row) {
		switch (cell) {
			case "F":
				return "Ž";
			default:
				return cell
		}
	}

	formatPersonalId(cell, row) {
		return <Link to={{pathname: "/users/" + row.userId}}>{row.personalId}</Link>
	}

	formatRow(row, index) {
		return (row && row.status === 'DELETED' ? "alert-muted" : null)
	}

	getFilter() {
		const {filter} = this.state;
		const {enums} = this.props;

		const statuses = [
			{value: 'NEW', label: 'Nepotvrzený'},
			{value: 'ACTIVE', label: 'Aktivní', title: 'Potvrzený - aktivní'},
			{value: 'DELETED', label: 'Ukončený'}
		];

		return [
			<Row key="1">
				<Col xs={2}>
				</Col>
				<Col xs={2}>
					<FormGroup>
						<FormControl type="text" value={filter.search} name="search" placeholder="Příjmení, průkaz" onChange={this.handleInputChange}/>
					</FormGroup>
				</Col>
				<Col xs={2}>
					{Grid.renderSelect("roleIds", "(všechny role)", filter.roleIds, Enums.createEnumItems(enums, "roles"), this.handleSelectChange)}
				</Col>
				<Col xs={6}>
					<Row>
						<Col xs={7}>
							<FormButtons currentValue={filter.statuses} options={statuses} name="statuses" onInputChange={this.handleInputChange}/>
						</Col>
						{Grid.renderFilterButtons(this.onFilterReset, 5, () => {
							return '/rest-service/user/export/?' + qs.stringify(filter)
						})}
					</Row>
				</Col>
			</Row>];
	}

	getCols() {
		let cols = [
			<TableHeaderColumn key="0" dataField="userId" width='5%' dataAlign="center" dataSort={true}>#</TableHeaderColumn>,
			<TableHeaderColumn key="2" dataField="lastName" width='20%' dataSort={true}>Příjmění</TableHeaderColumn>,
			<TableHeaderColumn key="3" dataField="firstName" width='20%' dataSort={true}>Jméno</TableHeaderColumn>,
		];

		cols.push(
			<TableHeaderColumn key="14" dataField="status" width='10%' dataAlign="center" dataFormat={this.formatStatus}>Stav</TableHeaderColumn>);

		return cols;
	}

	render() {
		const {isFetchingItems, items, count, filter, session} = this.props;

		const actions = [];
		if (Acl.isAllowed(session, Acl.right.USER_EDIT_LIMITED)) {
			actions.push({
				value: "archive",
				label: 'Archivovat vše'
			})
		}

		const actionCtx = actions.length > 0 ? {
			onActionSelect: this.handleActionSelect,
			onActionSubmit: this.handleActionSubmit,
			value: this.state.action,
			key: 'userId',
			selectRowProp: {
				mode: 'checkbox',
				clickToSelect: true,
				onSelect: this.handleRowSelect,
				onSelectAll: this.handleRowSelectAll,
				selected: this.state.actionItems,
				bgColor: function (row, isSelect) {
					if (isSelect) {
						return "#fcf8e3"
					}
					return null;
				},
				unselectable: []
			},
			actions: actions
		} : null;

		if (items && !Acl.isAllowed(session, Acl.right.USER_NEW_GLOBAL)) {
			for (let i = 0; i < items.length; i++) {
				if (items[i].userId) {
					actionCtx.selectRowProp.unselectable.push(items[i].userId)
				}
			}
		}

		return <div>{Grid.renderFull(isFetchingItems, items, count,
			Grid.getTableOptions(filter, this.onPageChange, this.onSortChange, this.onFilterChange, this.renderPaginationShowsTotal),
			this.getCols(),
			this.getFilter(),
			this.onFilterChange,
			actionCtx, this.formatRow)}
			{this.renderActionModal()}
		</div>
	}
}


Users.propTypes = {
	onFetchEnums: PropTypes.func.isRequired,
	enums: PropTypes.object.isRequired,
	onShowModal: PropTypes.func.isRequired,
	onUpdateUserStatus: PropTypes.func,
	onShowMessage: PropTypes.func.isRequired
};

export default withRouter(Users)
